<a class="pointer" (click)="back()"> < Volver</a>
<div class="jumbotron animated fadeIn fast">
  <div class="container-fluid">
    <div class="container">
      <div class="row row-margin text-center">
        <h3 class="title">Carga de Solicitud</h3>
        <div class="space-bar center-block"></div>
        <app-alert *ngIf="error" [alert]="error"></app-alert>
      </div>
      <app-loading *ngIf="loading"></app-loading>
      <div *ngIf="!loading">
        <div class="row row-margin text-center">
          <p>
            Estimado, estos son los datos de la planilla adjunta:
          </p>
        </div>
        <div class="row text-center">
          <div class="col-md-6 col-table left">
            <div class="row text-left first">
              <div class="col-md-6">
                <span><b>Ruc Empresa</b></span>
              </div>
              <div class="col-md-6">
                <span>{{ _request.request.ruc }}</span>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-md-6">
                <span><b>Nombre / Razón social</b></span>
              </div>
              <div class="col-md-6">
                <span>{{ _request.request.companyName }}</span>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-md-6">
                <span><b>Monto total</b></span>
              </div>
              <div class="col-md-6">
                <span>{{ _request.request.amount | currency:'':'' | customCurrency: _request.request.currency }}</span>
              </div>
            </div>
            <div class="row text-left last">
              <div class="col-md-6">
                <span><b>Moneda</b></span>
              </div>
              <div class="col-md-6">
                <span>{{ _request.request.currency }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-table">
            <div class="row text-left first">
              <div class="col-md-6">
                <span><b>Tipo de solicitud</b></span>
              </div>
              <div class="col-md-6">
                <span>{{ _request.request.type.name }}</span>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-md-6">
                <span><b>Cantidad de registros</b></span>
              </div>
              <div class="col-md-6">
                <span>{{ _request.request.totalRecords | number }}</span>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-md-6">
                <span><b>Fecha de carga</b></span>
              </div>
              <div class="col-md-6">
                <span>{{ _request.request.date | date:'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-margin">
          <button
            class="button-continue center-block"
            (click)="create()"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
